import { Component, EventEmitter, forwardRef, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { QueryOperator } from '../../models/filter-model';

@Component({
  selector: 'app-custom-search-input',
  templateUrl: './custom-search-input.component.html',
  styleUrls: ['./custom-search-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomSearchInputComponent),
      multi: true
    }
  ]
})
export class CustomSearchInputComponent implements OnInit, ControlValueAccessor, OnChanges {

  @Input() set defaultFilterValue(value: string) {
    this.searchValue = value;
    this.propagateChange(value);
  }
  @Input() showTipIcon = false;

  @Input() placeholder: string = '';
  @Input() showQueryOperator: boolean = false;
  @Input() value: string;
  @Input() operator: QueryOperator;
  @Output() changed = new EventEmitter<string>();
  @Output() changedMap = new EventEmitter<Map<string, any>>();
  @Output() changedOperator = new EventEmitter<Map<string, any>>();
  searchValue: string = '';
  queryOperator: QueryOperator = QueryOperator.EQUALS;
  isDisabled: boolean;
  queryOperatorValues = Object.values(QueryOperator);
  searchValueMap: Map<string, any> = new Map();

  constructor() {
  }

  ngOnInit(): void {
    if (this.value && this.operator) {
      this.searchValue = this.value;
      this.queryOperator = this.operator;
      this.searchValueMap.set('value', this.searchValue);
      this.searchValueMap.set('operator', this.queryOperator)
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.value) {
      this.searchValue = this.value;
    }
  }

  private propagateChange: any = () => {
  };
  private propagateTouched: any = () => {
  };

  writeValue(value: string): void {
    this.searchValue = value;

    if (this.showQueryOperator) {
      this.searchValueMap.set('value', this.searchValue);
      this.searchValueMap.set('operator', this.queryOperator);
    }
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.propagateTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  onKeyup(value: string): void {
    if (this.showQueryOperator) {
      this.searchValue = value;
      this.propagateChange(value);
      if (!this.searchValue) {
        this.changedMap.emit(null);
        return;
      }
      this.searchValueMap.set('value', this.searchValue);
      this.searchValueMap.set('operator', this.queryOperator);
      this.changedMap.emit(this.searchValueMap);
    } else {
      this.searchValue = value;
      this.propagateChange(value);
      if (!this.searchValue) {
        this.changed.emit(null);
        return;
      }
      this.changed.emit(value);
    }
  }

  onBlur(): void {
    this.propagateTouched();
  }

  onOperatorChange(event: any) {
    if (this.showQueryOperator) {
      if (Array.isArray(this.searchValue)) {
        this.searchValue = this.searchValue[0];
      }

      this.searchValueMap.set('value', this.searchValue);
      this.searchValueMap.set('operator', this.queryOperator);
    }
    this.changedOperator.emit(this.searchValueMap);
  }
}
